<template>
    <div class="g2-rank">
        <div class="g2-rank-title">{{title}}</div>
        <ul class="g2-rank-list">
            <li v-for="(el, i) in list" :key="i">
                <Row>
                    <Col span="16">
                        <div class="g2-rank-name">
                            <span :class="i <= 2 ? 'top' : ''">{{i + 1}}</span>
                            {{el.name}}
                        </div>
                    </Col>
                    <Col span="8">
                        <div class="g2-rank-money">{{el.value}}</div>
                    </Col>
                </Row>
            </li>
        </ul>
    </div>
</template>
<script>
    /**
     * 排名
     */
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            list: {
                type: Array,
                default: () => new Array()
            }
        }
    }
</script>
<style>
    .g2-rank {
        padding-left: 25px
    }
    .g2-rank-title {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 15px;
    }
    .g2-rank-list {
        list-style: none;
    }
    .g2-rank-list > li {
        margin-top: 12px;
    }
    .g2-rank-name {
        font-size: 14px;
    }
    .g2-rank-name > span {
        display: inline-block;
        width: 18px;
        height: 18px;
        color: #000;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        border-radius: 9px;
        background-color: #F0F2F5;
    }
    .g2-rank-name > span.top {
        color: #fff;
        background-color: #314659;
    }
    .g2-rank-money {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/g2-chart/src/rank.vue